import type { FetchiosError } from "@caprikorn/dynamo-utils";
import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { GetMaximalPower, GetMaximalPowerParams } from "./apiEcms.types";

const getMaximalPower = async (
  { customerId, contractId, siteId }: GetMaximalPowerParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<GetMaximalPower>(
    `/maximal-power/${customerId}/${contractId}/${siteId}`,
    {
      signal,
    },
  );

  return data;
};

export const useGetMaximalPower = ({
  customerId,
  contractId,
  siteId,
}: GetMaximalPowerParams) => {
  const { currentGroup } = useGroupReferences();

  return useQuery<GetMaximalPower, FetchiosError, GetMaximalPower[]>({
    queryKey: [
      QUERY_KEYS.MAXIMAL_POWER,
      customerId,
      contractId,
      siteId,
      currentGroup,
    ],
    queryFn: ({ signal }) =>
      getMaximalPower({ customerId, contractId, siteId }, signal),
    select: (data) => [data],
  });
};
